import { importHighcharts } from '@/lib/highcharts'
import { BlockModule } from '../common'
import {
    baseLineChartConfig,
    doIfInViewOrDefer,
    setupChartCounters,
    trendColorClasses,
    trendIconClasses,
} from './common'
import { getMarketDataExternalSectorExportsYoy } from '@/api'
import { defineComponent } from 'vue'
import ChartShareButtons from '@/components/website/ChartShareButtons.vue'
import { parseISO } from 'date-fns'

new BlockModule({
    selector: '.block-market-data-external-sector-exports-yoy',
    vueComponent: defineComponent({
        components: { ChartShareButtons },
        setup() {},
    }),
    async setupBlock(el, onTeardown, blockContext) {
        const chartData = await getMarketDataExternalSectorExportsYoy()

        const latestValue = chartData.data[chartData.data.length - 1]
        const beforeLatestValue = chartData.data[chartData.data.length - 2]
        const valueDelta = (latestValue.y || 0) - (beforeLatestValue.y || 0)

        const timestamp = chartData.lastUpdated
        const date = new Date(timestamp)
        const lastUpdatedValue = date
            .toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            })
            .replace(',', '')
        let trend: keyof typeof trendColorClasses & keyof typeof trendIconClasses = 'neutral'

        if (valueDelta > 0) {
            trend = 'positive'
        } else if (valueDelta < 0) {
            trend = 'negative'
        }

        const setupChart = async () => {
            const chartEl = el.querySelector('.chart-container')
            if (!chartEl) return

            const Highcharts = await importHighcharts()

            Highcharts.setOptions({
                lang: {
                    numericSymbols: undefined,
                },
            })

            const dataOverTime = chartData.data.map((point) => {
                return [parseISO(point.x + 'Z').valueOf(), point.y]
            })

            const chart = Highcharts.chart({
                ...baseLineChartConfig,
                chart: {
                    ...baseLineChartConfig.chart,
                    renderTo: chartEl as HTMLElement,
                },
                yAxis: {
                    color: '#DBDBDB',
                    title: {
                        text: '(%)',
                        align: 'high',
                        rotation: 0,
                        reserveSpace: false,
                        textAlign: 'left',
                        y: -20,
                    },
                },
                xAxis: {
                    labels: {
                        format: '{value:%Y}',
                    },
                    type: 'datetime',
                    lineColor: '#DBDBDB',
                },
                exporting: {
                    enabled: false,
                    filename: 'market-data-external-sector-exports-yoy',
                },
                series: [
                    {
                        name: chartData.yLabel,
                        type: 'line',
                        color: '#010066',
                        data: dataOverTime,
                    },
                ],
            })

            const download = el.querySelector<HTMLButtonElement>('.download-btn')
            if (download) {
                download.addEventListener('click', () => {
                    chart.downloadCSV()
                })
            }

            onTeardown(() => {
                chart.destroy()
            })
        }

        doIfInViewOrDefer(() => {
            setupChart()
            setupChartCounters(
                el,
                trend,
                latestValue,
                beforeLatestValue,
                null,
                valueDelta,
                timestamp,
                lastUpdatedValue,
                null,
                null,
                null,
                null,
                false,
            )
        }, blockContext)
    },
})
